/* =====================================================================
   Print offer (custom, ShopiCraft)
   Product page only: refreshes the progress in the "Print offer" block
   after the cart changes, without a page reload. It re-renders
   sections/print-offer-progress.liquid (same Liquid as the cart drawer),
   because /cart.js does not include product collections.
   ===================================================================== */
(function () {
  'use strict';

  var SECTION_ID = 'print-offer-progress';
  var controller = null;

  function normalise(el) {
    return el.textContent.replace(/\s+/g, ' ').trim();
  }

  function refresh() {
    var targets = document.querySelectorAll('[data-print-offer-live]');
    if (!targets.length) return;

    // Several cart events can fire for one add; only the latest request counts
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart?section_id=' + SECTION_ID, {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-print-offer-live-source]');
        if (!source) return;

        Array.prototype.forEach.call(targets, function (target) {
          // Only replace when the text changed, so screen readers don't repeat the same message
          if (normalise(target) !== normalise(source)) target.innerHTML = source.innerHTML;

          var card = target.closest('.print-offer');
          if (card) card.classList.toggle('is-done', !!target.querySelector('[data-print-offer-done]'));
        });
      })
      .catch(function () { /* aborted or offline: keep the current message */ });
  }

  // One add to cart fires several events and re-draws the drawer; wait for them to settle and refresh once
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 200);
  }

  // Warehouse dispatches these on <html> or document depending on the event; listen on both
  ['product:added', 'cart:refresh', 'cart:rerendered'].forEach(function (name) {
    document.addEventListener(name, scheduleRefresh);
    document.documentElement.addEventListener(name, scheduleRefresh);
  });

  // Cart drawer quantity changes and removals don't fire an event we can rely on, so watch for the drawer re-drawing itself
  var drawer = document.getElementById('mini-cart');
  if (drawer && drawer.parentNode && window.MutationObserver) {
    new MutationObserver(scheduleRefresh).observe(drawer.parentNode, { childList: true, subtree: true });
  }
  
  // Back/forward cache: the page may come back with an old cart
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();